import { DesignSystemPrimitive } from 'designSystem/types';
import { resolveTokenValue } from 'designSystem/tokens/resolver';
import * as S from './styles';

interface TypographyPrimitivePreviewProps {
	primitive: DesignSystemPrimitive;
}

export const TypographyPrimitivePreview = ({ primitive }: TypographyPrimitivePreviewProps) => {
	// Create inline styles from CSS properties, resolving token references
	const inlineStyles: React.CSSProperties = {};
	primitive.properties.forEach((prop) => {
		const cssProp = prop.name.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
		const resolvedValue = resolveTokenValue(prop.value);
		if (cssProp === 'fontSize') {
			inlineStyles.fontSize = resolvedValue;
		} else if (cssProp === 'fontWeight') {
			inlineStyles.fontWeight = resolvedValue;
		} else if (cssProp === 'lineHeight') {
			inlineStyles.lineHeight = resolvedValue;
		} else if (cssProp === 'color') {
			inlineStyles.color = resolvedValue;
		} else if (cssProp === 'letterSpacing') {
			inlineStyles.letterSpacing = resolvedValue;
		} else if (cssProp === 'textTransform') {
			inlineStyles.textTransform = resolvedValue as any;
		}
	});

	const getSampleText = () => {
		if (primitive.baseSelector.includes('heading')) return 'Heading';
		if (primitive.baseSelector.includes('text-muted')) return 'Muted text';
		if (primitive.baseSelector.includes('text-soft')) return 'Soft text';
		if (primitive.baseSelector.includes('text-label')) return 'LABEL';
		return 'Sample text';
	};

	return (
		<S.PrimitivePreview>
			<div style={inlineStyles}>{getSampleText()}</div>
		</S.PrimitivePreview>
	);
};
